import {
  React,
  Component,
  withRouter,
  withCookies,
  RichTextEditor,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  Paper,
} from 'material-ui';


import {
  PrimaryButton,
  SecondaryButton,
  AlertDialog,
  AlertDialogWithComments,
  AlertDialogOneButton,
  LoadingDialog,
  GreyColor2,
} from 'imports/DesignImports';

import {
  ProjectInformation,
  ProjectPreview,
  SignButtonComponent,
} from 'imports/ComponentsImports';

//TODO: Sacar hardcodeo
const API_KEY = "AIzaSyDpWo5PvDlwr1qCxIaj3pVVbsOnQDxCxg0";

const styles = {
  container: {
    backgroundColor: GreyColor2,
    borderRadius: '0px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop:'20px',
  },
  buttonStyle: {
    border: '1px black solid',
    marginTop: '10px',
    fontFamily: 'Lato'
  }
};

const saveState = {
  success: "SUCCESS",
  error: "ERROR",
  waiting: "WAITING"
}

class ProjectShow extends Component {
  constructor(props){
    super(props);
    this.state = {
      alert: false,
      loading: false,
      error: false,
      alertDialogOneButton: false,
      alertMessage: '',
      cancelLabel: '',
      acceptLabel: '',
      loadingData: false,
      loadingMessage: '',
      save: false,
      generalSnackbar: false,
      showPreview: false,
      snackMessage: '',
      token: props.cookies.get('token'),
      user: props.cookies.get('user'),
      justification: '',
      activeTab: 0,
      project: props.project,
      method: RichTextEditor.createEmptyValue(),
      problem: props.project.information.problem,
      solution: props.project.information.solution,
      objectives: props.project.information.objectives,
      characteristics: props.project.information.characteristics,
      benefits: props.project.information.benefits,
    }
  }

  render() {
    const { user, project } = this.state;
    return(
      <div style={{display: 'flex', flexDirection:'column'}}>
        <Paper zDepth={2} style={styles.container}>
          <ProjectInformation 
            project={this.state.project} 
            signatures={this.props.signatures} 
            token={this.state.token} 
            user={this.state.user} 
            handleInformationChange={this.handleInformationChange}
          />
        </Paper>
        <div style={styles.buttonContainer}>
          {user.position === 'Líder de proyecto' || project.information.leader_email === user.email || project.state[0].state !== 'En proceso de firma' ?
            [
              <SecondaryButton key={1} label="Guardar" onClick={this.saveData}/>,
              <PrimaryButton key={2} label="Finalizar Ficha"
              onClick={this.checkCompleteness}/>
            ]
          : null
          }
          {this.state.user.position !== 'Líder de proyecto' && this.state.project.state[0].state === "En proceso de firma" ?
            <SignButtonComponent token={this.state.token} project={this.state.project} user={this.state.user}/>
          :null
          }
          {['En proceso de firma', 'Ficha aprobada', 'Finalizado'].includes(this.state.project.state[0].state) && this.state.user.position !== 'Líder de proyecto' ?
            this.state.project.state[0].state === "No trazable"
            ? <SecondaryButton label="Declarar 'Trazable'" onClick={() => {this.raiseAlert("¿Quiere volver a hacer el proyecto trazable?", this.switchTraceability)}}/>
            : <SecondaryButton label="Declarar 'No Trazable'" onClick={() => {this.raiseAlertWithComment("¿Cuál es la justificación para declarar este proyecto como 'No trazable'?", this.switchTraceability)}}/>
          : null
          }
        </div>
        {this.state.alert ?
          <AlertDialog
            title='¡Atención!'
            acceptLabel={this.state.acceptLabel}
            cancelLabel={this.state.cancelLabel}
            message={this.state.alertMessage}
            confirm={this.state.confirm}
            cancel={this.cancelAlert}/> : null}
        { this.state.alertDialogOneButton ?
          <AlertDialogOneButton
            title={this.state.alertTitle}
            message={this.state.alertMessage}
            acceptLabel={this.state.acceptLabel}
            confirm={this.state.confirm}/> : null}
        {this.state.loadingData ? <LoadingDialog message={this.state.loadingMessage} /> : null}
        {this.state.alertWithComment ? <AlertDialogWithComments mandatoryComment={true} message={this.state.alertMessage} confirm={this.state.confirm} cancel={this.cancelAlertWithComment} handleCommentChange={this.handleJustificationChange}/> : null}
        {this.state.showPreview ? <ProjectPreview companyName={this.state.user.company_name} handleClose={this.handlePreviewClose} project={this.state.project}/> : <div></div>}
      </div>
    )
  }

  handleInformationChange = (type, value) => {
    this.setState({[type]: value});
  };

  closeLoadingMessage = () => {
    this.setState({loadingData: false, loadingMessage: ""});
  }

  openLoadingMessage = (message) => {
    this.setState({loadingData: true, loadingMessage: message});
  }

  checkCompleteness = () => {
    let project = this.state.project
    var allCompleted = this.state.problem !== '' && this.state.solution !== '' && this.state.objectives !== '' && this.state.characteristics !== '' && this.state.benefits !== '';
    console.log(this.state);
    if (allCompleted) {
      this.raiseAlert("¿Está seguro que desea finalizar el proyecto y enviarlo a validar con los gerentes?", "Sí, finalizar", "No, volver", this.finishProject)
    }
    else {
      this.raiseOneButtonAlert("¡Faltan campos!", "Debes terminar cada sección del proyecto antes de marcar el proyecto completo como finalizado", "Aceptar", () => this.setState({alertDialogOneButton: false}))
    }
  }

  getProject = () => {
    this.openLoadingMessage("Estamos recargando la información del proyecto")
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.oneProjectFullInformation(this.state.project.id))
    .then((response) => {
      this.closeLoadingMessage();
      this.setState({project: response.data});
    })
    .catch((error) => {
      this.closeLoadingMessage();
      console.error(error);
    })
  }

  handlePreviewClose = () => {
    this.setState({showPreview: false});
  }

  createPreview = () => {
    this.setState({
      showPreview: true
    });
  }

  cancelAlert = () => {
    this.setState({
      alert:false
    })
  }

  cancelAlertWithComment = () => {
    this.setState({
      alertWithComment:false
    })
  }

  saveData = () => {
    this.saveDataRequest()
    .then((response) => {
      this.closeLoadingMessage();
      this.raiseOneButtonAlert('¡Felicidades!', 'Has guardado tu progreso de la ficha del proyecto', 'Aceptar', this.getProject)
    })
    .catch((error) => {
      this.setState({ error: true })
      this.closeLoadingMessage();
      this.raiseOneButtonAlert('¡Error!', 'Hubo problemas al guardar la información. Intenta nuevamente', 'Aceptar', () => this.setState({alertDialog: false}))
    });
  }

  saveDataRequest = () => {
    this.openLoadingMessage("Estamos guardando tu trabajo, espera un momento");
    let informationData = {
      problem: this.state.problem,
      solution: this.state.solution,
      objectives: this.state.objectives,
      characteristics: this.state.characteristics,
      benefits: this.state.benefits,
    }
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    return connection.patch(this.state.project.information.url, informationData)

  }

  switchTraceability = () => {
    this.openLoadingMessage("Estamos guardando tu decisión, espera un momento")
    axios({
      method: 'patch',
      headers: {'Authorization': "Token "+ this.state.token},
      url: routes.host + routes.switchTraceability(this.state.project.id),
      data: {justification: this.state.justification}
    })
    .then((response) => {
      if(this.state.loadingData)
        this.closeLoadingMessage();
      this.setState({ generalSnackbar: true, snackMessage: 'La trazabilidad del proyecto se cambió con éxito', alertWithComment: false})
      this.getProject();
    })
    .catch((error) => {
      if(this.state.loadingData)
        this.closeLoadingMessage();
      this.setState({ generalSnackbar: true, snackMessage: 'Hubo un error al cambiar la trazabilidad del proyecto, por favor intente nuevamente', alertWithComment: false})
    });
  }

  finishProject = () => {
    let project = this.state.project
    this.setState({
      alert:false
    })
    this.saveDataRequest()
    .then((response) => {
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      connection.patch(routes.startSignatureProcess(project.id), {})
      .then((response) => {
        if(this.state.loadingData)
        this.closeLoadingMessage();
        this.raiseOneButtonAlert(
          '¡Excelente!',
          'Has finalizado el proyecto con éxito, esto significa que tu ya lo validaste. A continuación lo validará el gerente de área, el gerente de innovación y el gerente de finanzas',
          'Aceptar',
          () => {this.setState({alertDialogOneButton: false}); this.getProject()})
      })
      .catch((error) => {
        if(this.state.loadingData)
          this.closeLoadingMessage();
        this.raiseOneButtonAlert('¡Error!', 'Hubo problemas al finalizar el proyecto, probablemente falta el valor del indicador en algún año o algún archivo', 'Aceptar', () => this.setState({alertDialogOneButton: false}))
      });
    })
    .catch((error) => {
      this.setState({ error: true })
      this.closeLoadingMessage();
      this.raiseOneButtonAlert('¡Error!', 'Hubo problemas al guardar la información. Intenta nuevamente', 'Aceptar', () => this.setState({alertDialogOneButton: false}))
    });
  }

  raiseAlert = (message, acceptLabel, cancelLabel, func) => {
    this.setState({
      alert: true,
      alertMessage: message,
      acceptLabel: acceptLabel,
      cancelLabel: cancelLabel,
      confirm: func
    })
  }

  raiseAlertWithComment = (message, func) => {
    this.setState({
      alertWithComment: true,
      alertMessage: message,
      confirm: func
    })
  }

  handleJustificationChange = (event) => {
    this.setState({justification: event.target.value})
  }

  raiseOneButtonAlert = (title, message, acceptLabel, confirm) => {
    this.setState({alertDialogOneButton: true, alertTitle: title, alertMessage: message, acceptLabel: acceptLabel, confirm: confirm})
  }
}

export default withRouter(withCookies(ProjectShow));



// WEBPACK FOOTER //
// ./src/components/files/ProjectShow.js